/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import classnames from 'classnames';

import { Tabs, TabsData } from 'components/molecules/SwitchTab';
import NewsCard, { NewsCardProperty } from 'components/molecules/NewsCard';
import Article from 'images/icon/article.inline.svg';

import { NewsListType } from 'models/blog';

import EmptyArea from 'components/atoms/EmptyArea';
import styles from './index.module.css';

interface NewsTabProperty {
	tabsData: TabsData;
	data: NewsListType;
	className?: string;
}

const NewsTab: React.FC<NewsTabProperty> = ({ tabsData, data, className }) => {
	const [activeIndex, setActiveIndex] = useState<number>(0);

	return (
		<div className={classnames(styles.newsTab, className)}>
			<Tabs
				data={tabsData}
				activeIndex={activeIndex}
				handleClick={(newIndex: number) => setActiveIndex(newIndex)}
			/>
			{Object.values(data)[activeIndex].length !== 0 ? (
				<div className={styles.cards}>
					{Object.values(data)[activeIndex].map(news => (
						<NewsCard
							{...(news as unknown as NewsCardProperty)}
							className={styles.card}
							key={news.title}
							link={
								tabsData[activeIndex].id
									? `/blog/${news.id}?categoryId=${tabsData[activeIndex].id}`
									: `/blog/${news.id}`
							}
						/>
					))}
				</div>
			) : (
				<EmptyArea svg={Article} title="目前沒有相關消息" className={styles.noArticle} />
			)}
		</div>
	);
};

export default NewsTab;
